<template>
  <el-dialog :append-to-body="true" id="contact-list-layer" title="添加签署方" :visible.sync="dialogVisible" width="720px"
    :center="true">
    <div id="template-list-layer">
      <el-table :data="templateData" size="small" style="width: 100%; width: 100%; ">
        <el-table-column prop="account" label="账号" align="center"></el-table-column>
        <el-table-column prop="subjectName" label="名称" align="center"></el-table-column>
        <el-table-column v-if="templateType == 1" prop="agentAccount" label="经办人账号" align="center"></el-table-column>
        <el-table-column v-if="templateType == 1" prop="agentName" label="经办人名称" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" style="margin-left:10px;" class="text-btn"
              @click="deleteSignatory(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="dialog-btns">
        <el-button type="primary" @click="addBatch" class="btn-ok">确认添加</el-button>
        <el-button type="info" @click="cancel" class="btn-cancel">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      templateData: [],
      templateType: 0 // 0 个人 1 企业
    }
  },
  methods: {
    deleteSignatory(signatory) {
      this.$confirm('确定要删除吗？', '温馨提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        this.templateData.forEach((temp, i) => {
          if (temp.account === signatory.account && temp.subjectName === signatory.subjectName && temp.agentAccount === signatory.agentAccount && temp.agentName === signatory.agentName) {
            this.templateData.splice(i, 1)
          }
        })
      }).catch(() => {

      })
    },
    addBatch() {
      this.$emit('saveBatch', this.templateData)
      this.cancel()
    },
    cancel() {
      this.dialogVisible = false
    }
  },
}
</script>

<style scoped>
#contact-list-layer .dialog-btns {
  width: 475px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.dialog-btns button {
  display: block;
  width: 179px;
  height: 50px;
  font-size: 18px;
  border-radius: 10px;
}
</style>